<footer class="footer">
  <div class="container-xxl">
    <div nz-row nzGutter="48">
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="10" [nzXl]="10" class="footer-contact">
        <h3>Carvry</h3>
        <span class="text-center font-size-13">Carvry does not broker, sell, or lease motor vehicles.
            All vehicles shown on this website are offered for sale by licensed motor vehicle dealers or private sellers.
            All vehicles are subject to prior sale. By accessing this website, you agree to the Carvry Terms & Conditions
            and Privacy Policy. Vehicle Images by EVOXImages.com
          </span>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="4" [nzXl]="4" class="footer-links">
        <h4>Useful Links</h4>
        <ul>
          <li><a aria-label="Home" [routerLink]="'/explore'">Home</a></li>
          <li><a aria-label="Blog" [routerLink]="'/blogs'">Blog</a></li>
          <li><a aria-label="FAQs" [routerLink]="'/faqs'">FAQs</a></li>
        </ul>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="4" [nzXl]="4" class="footer-links">
        <h4>Products</h4>
        <ul>
          <li><a aria-label="Your Car Research" [routerLink]="'/view-all-research'">Your Car Research</a></li>
          <li><a aria-label="Saved Vehicles" [routerLink]="'/saved-vehicles'">Saved Vehicles</a></li>
        </ul>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" class="footer-others">
        <h4>Others</h4>
        <p class="address">Austin, TX, 78701 United States</p>
        <p class="email">Email: contact@carvry.com</p>

        <div class="social-links">
          <a href="https://twitter.com/CarvryApp" target="_blank" aria-label="Twitter Link">
            <i nz-icon nzTheme="outline" nzType="twitter"></i>
          </a>
          <a href="https://instagram.com/CarvryApp" target="_blank" aria-label="Instagram Link">
            <i nz-icon nzTheme="outline" nzType="instagram"></i>
          </a>
          <a href="https://facebook.com/carvry" target="_blank" aria-label="Facebook Link">
            <i nz-icon nzTheme="outline" nzType="facebook"></i>
          </a>
          <a href="https://linkedin.com/company/carvry" target="_blank" aria-label="LinkedIn Link">
            <i nz-icon nzTheme="outline" nzType="linkedin"></i>
          </a>
        </div>
      </div>
    </div>
    <div nz-row class="additional-info-wrapper">
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="10" [nzXl]="12">
        <div class="copyright">
          Copyright &copy; {{date}} <strong><span>Dealer Curator LLC</span></strong>. All Rights Reserved
        </div>
      </div>
      <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="16" [nzLg]="14" [nzXl]="12">
        <div class="additional-info-links">
          <a aria-label="Terms & Conditions" [routerLink]="'/terms'">Terms & Conditions</a>
          <a aria-label="Privacy policy" [routerLink]="'/privacy'">Privacy policy</a>
          <a aria-label="Legal FAQs" [routerLink]="'/legal-faq'">Legal FAQs</a>
          <a aria-label="Sitemap" href="{{sitemapUrl}}">Sitemap</a>
        </div>
      </div>
    </div>
  </div>
</footer>
